import { useNavigationModule } from "@agp/shared.user-app/application/context/navigation";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";
import ServiceLocator from "../../../../../domain/service-locator";
import { useMemo } from "react";
import { Area } from "@agp/shared.user-app/entity";
import { useLanguageBasedFont } from "../../const/font-utils";

export const MonotoneAreasPage = () => {
  const languageRepository = ServiceLocator.LanguageRepository;
  const localizedEntityRepository = ServiceLocator.LocalizedEntityRepository;
  const { areas } = localizedEntityRepository.entities.watch();
  const currentLanguageId = languageRepository.currentLanguageId.watch();
  const navigation = useNavigationModule();
  const fontClass = useLanguageBasedFont();

  const currentLanguage = useMemo(
    () => languageRepository.languages.find((x) => x.id === currentLanguageId)!,
    [languageRepository, currentLanguageId]
  );

  const handleClickArea = (area: Area) => {
    navigation.push(
      "guides",
      {
        areaId: area.id,
      },
      {
        pageOutType: "fade",
        pageInType: "fade",
      }
    );
  };

  return (
    <AnimatedPageTransition>
      <div
        className={`bg-white flex items-center justify-around p-4 ${fontClass}`}
        style={{ height: window.innerHeight }}
      >
        <div className="px-[12px] relative flex flex-col items-center justify-center gap-[80px] bg-[#F2F2F2] rounded-3xl max-w-md w-full h-[90%] max-h-[638px] py-4 text-center">
          {currentLanguage.localeId === "ja-JP" ? (
            <>
              {areas
                .filter((x) => !x.isDefault)
                .map((area) => (
                  <div
                    key={area.id}
                    className={"flex flex-col justify-center w-[90%]"}
                    onClick={() => handleClickArea(area)}
                  >
                    <div
                      className={
                        "whitespace-pre-wrap bg-white py-4 text-2xl rounded-full w-full shadow-[0_0_20px_rgba(0,0,0,0.3)]"
                      }
                    >
                      {area.name}
                    </div>
                    <div className={"mt-5 text-gray-500"}>ナレーション</div>
                    <div className={"mt-5 text-2xl font-semibold"}>
                      {/*TODO: CHANEL用の特殊実装のため、後々汎用化する*/}
                      {area.name.includes("Beyond") ? "安藤サクラ" : "小松菜奈"}
                    </div>
                  </div>
                ))}
            </>
          ) : (
            <>
              {areas
                .filter((x) => !x.isDefault)
                .map((area) => (
                  <div
                    key={area.id}
                    className={"flex flex-col justify-center w-[90%]"}
                    onClick={() => handleClickArea(area)}
                  >
                    <div
                      className={
                        "whitespace-pre-wrap bg-white py-4 text-2xl rounded-full w-full shadow-[0_0_20px_rgba(0,0,0,0.3)]"
                      }
                    >
                      {area.name}
                    </div>
                    <div className={"mt-5 text-gray-500"}>Narration</div>
                    <div className={"mt-5 text-2xl font-semibold"}>
                      {/*TODO: CHANEL用の特殊実装のため、後々汎用化する*/}
                      Hio Miyazawa
                    </div>
                  </div>
                ))}
            </>
          )}
        </div>
      </div>
    </AnimatedPageTransition>
  );
};
